import { forwardRef } from 'react';

import { styled } from '@mui/material/styles';
import MuiTab, { TabProps as MuiTabProps } from '@mui/material/Tab';
import { shouldForwardProp as sysShouldForwardProp } from '@mui/system';
import Typography from "../Typography";
import type { HeadlinesType } from '../Tabs';

export * from '@mui/material/Tab';

export interface TabProps extends MuiTabProps {
  subMenu?: 'desktop' | 'mobile';
  color?: 'internal';
  textVariant?: HeadlinesType;
}

const StyledMuiTab = styled(MuiTab, {
  shouldForwardProp: (prop) => sysShouldForwardProp(prop) && prop !== 'subMenu',
})(() => ({}));

const Tab = forwardRef<HTMLDivElement, TabProps>(({ label, textVariant, ...props }, ref) => {
  const labelVal = textVariant ? (
    <Typography variant={textVariant} component="span">
      {label}
    </Typography>
  ) : (
    label
  );
  return <StyledMuiTab ref={ref} label={labelVal} {...props} />;
});

Tab.displayName = 'Tab';

export default Tab;
